"use client";

import React from "react";
import { CheckCircle2, X } from "lucide-react";
import styles from "../css/components/StockAvailabilityPill.module.css";

export default function StockAvailabilityPill({ quantity, onClose, className = "" }) {
  if (quantity === null || quantity === undefined) return null;

  const wrapperClass = [styles.wrapper, className].filter(Boolean).join(" ");
  const num = typeof quantity === "number" ? quantity : Number(quantity);
  const displayQty = Number.isFinite(num) ? num : quantity;

  return (
    <div className={wrapperClass}>
      <div className={styles.pill}>
        <CheckCircle2 className={styles.icon} size={16} aria-hidden />
        <span className={styles.text}>{`${displayQty} units in stock`}</span>
        {onClose && (
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Hide stock availability"
          >
            <X size={14} aria-hidden />
          </button>
        )}
      </div>
    </div>
  );
}
